/**
* 下面是公共变量和公共方法定义
*/

export const util = {
    //公共变量
    defLanguage:'zh',//en海外，zh国内
    //暴露封装
    formartDateTime: function(inputTime){
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
        var second = date.getSeconds();
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' '+h + ':' + minute+ ':' + second;
    },
    
    formartDate: function(inputTime){
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    },
   
    formatHMTSTime: function(inputTime){
        var date = new Date(inputTime);
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
        var second = date.getSeconds();
        second = second < 10 ? ('0' + second) : second;
        return h + ':' + minute+ ':' + second;
    },
    formatHMTime: function(inputTime){
        var date = new Date(inputTime);
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
        return h + ':' + minute;
    },
    //半小时
    formatHalfTime: function(inputTime){
        var date = new Date(inputTime);
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes() ;
        var halfTime=minute>=30?'30':'00';
        return h + ':' + halfTime;
    },     
    datetimeFormat:function(row,column){
        var dateText = row[column.property]; 
        if(dateText=="" ||dateText==null){
            return "";
        }
        let date = new Date(dateText);
        let Y = date.getFullYear() + '-';
        let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
        let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
        let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        let m = date.getMinutes()  < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
    },
    validDataFormat:function(row,column){
        
        var validDataText = row[column.property];
        if(row.validUser==3&&row.validType==0){
            var data=window.JSON.parse(validDataText);
            return data.data;
        }else{
           return validDataText;
        }
    },
    onlineFormat :function(row,column){ 
        var rtn ="";
        var validDataText = row[column.property];
        switch(validDataText){
           case 0:
            rtn=window.vm.$i18n.t("util.offline")
               break;
           case 1:
            rtn=window.vm.$i18n.t("util.online") 
                break;   
        }
        return rtn
    },
    validTypeFormat :function(row,column){ 
        var rtn ="";
        var validTypeText = row[column.property];
        switch(validTypeText){
           case 0:
            rtn= window.vm.$i18n.t("util.unknownUser") 
               break;
           case 1:
            rtn= window.vm.$i18n.t("util.remoteOpen")  
                break;
            case 2:
            rtn= window.vm.$i18n.t("util.passwordUser")     
                break;
            case 3:
            rtn= window.vm.$i18n.t("util.cardUser")    
                break;
            case 4:
            rtn= window.vm.$i18n.t("util.fingerprintUser")    
                break; 
            case 5:
             rtn= window.vm.$i18n.t("util.bleOpen") 
                break;                   
        }
        return rtn
    },
    tenantStatusFormat:function(row,column){   
        var rtn ="";
        var validTypeText = row[column.property];
        switch(validTypeText){
           case 0:
            rtn= window.vm.$i18n.t("util.noshow") 
               break;
           case 1:
            rtn=window.vm.$i18n.t("util.checkIn")  
                break;              
        }
        return rtn
    },
    authValidTypeFormat :function(row,column){ 
        var rtn ="";
        var authValidTypeText = row[column.property];
        switch(authValidTypeText){
           case 0:
            rtn=window.vm.$i18n.t("util.password")  
               break;
           case 1:
            rtn= window.vm.$i18n.t("util.card") 
                break;
            case 2:
            rtn= window.vm.$i18n.t("util.IDCard")  
                break;
            case 3:
            rtn= window.vm.$i18n.t("util.fingerprint")    
                break;
            case 4:
            rtn= window.vm.$i18n.t("util.ble")    
                break;                
        }
        return rtn;
    },
    authStatusFormat :function(row,column){
        var rtn ="";
        var authStatusText = row[column.property];
        switch(authStatusText){
           case 0:
            rtn= window.vm.$i18n.t("util.stop")    
               break;
           case 1:
            rtn= window.vm.$i18n.t("util.start")   
                break;
            case 2:
            rtn= window.vm.$i18n.t("util.invalid")    
               break;
            case 3:
            rtn= window.vm.$i18n.t("util.delete")       
               break;   
            case 4:
              rtn= "待删除"  
               break;              
        }
        return rtn;
    },
    timeoffFormat:function(row,column){
        // alert(window.JSON.stringify(row));
        var rtn ="";
        var vilidData = row[column.property];
        if(vilidData!=""&&vilidData!=null){
            if(row.validUser==3){
              var jsonData=window.JSON.parse(vilidData);
              if(jsonData.beginTime!=undefined){
                rtn=jsonData.beginTime+"-"+jsonData.endTime;
              }  
            }
       
        }
        return rtn;
    },
    apartmentTypeFormat:function(row,column){
        var rtn ="";
        var apartmentType = row[column.property];
        switch(apartmentType){
           case 0:
            rtn=window.vm.$i18n.t("util.fsx");
               break;
           case 1:
            rtn= window.vm.$i18n.t("util.jzx"); 
                break;
            case 2:
            rtn= window.vm.$i18n.t("util.jdx"); 
                break;       
        }
        return rtn;
    },
    //授权记录的开始时间显示格式
    authBeginTimeFormat:function(row,column){
        var dateText = row[column.property]; 
        if(dateText=="" ||dateText==null){
            return "";
        }
        let date = new Date(dateText);
        let Y = date.getFullYear() + '-';
        let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
        let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
        let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
        let m = date.getMinutes()  < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        if(row.validUser==3 &&row.validType==0){
            var validData=window.JSON.parse(row.validData);
            if(validData.beginTime==undefined||validData.beginTime==null){
                return Y + M + D + h + m + s; 
            }else{
                return "";
            }
       
        }else{
            return Y + M + D + h + m + s;
        }
    },
    //开门方式
    lockValidTypesFormat :function(validTypes){
       if(validTypes!="" && validTypes!=undefined){
       var validTypesArray=window.JSON.parse(validTypes);
       var rtn="";
       for(var str in validTypesArray){
         switch(validTypesArray[str]){
           case "00":
             rtn+=window.vm.$i18n.t("util.password")+",";
            break;
           case "01":
             rtn+=window.vm.$i18n.t("util.fingerprint")+",";
            break; 
           case "02":
             rtn+=window.vm.$i18n.t("util.card")+",";
            break;
           case "03":
             rtn+=window.vm.$i18n.t("util.ble")+",";
            break;  
         }
        }
       rtn=rtn.substring(0,rtn.length-1);
      }
      return rtn;
    },
    lockPowerTypeFormat(powerType){
        var rtn="";
        switch(powerType){
         case 0:
            rtn=window.vm.$i18n.t("util.batteryPower");
             break
         case 1:
            rtn=window.vm.$i18n.t("util.mainsLive"); 
             break;    
        }
        return rtn;
    },
    lockCommTypesFormat(commType){
       var rtn="";
       if(commType!="" && commType!=undefined){
         var commType=window.JSON.parse(commType);
         for(var str in commType){
            switch(commType[str]){
              case "00":
                rtn+="433,";
               break;
              case "01":
                rtn+=window.vm.$i18n.t("util.ble")+",";
               break; 
              case "02":
                rtn+=window.vm.$i18n.t("util.notNetwork")+",";
               break;
            }
          }
          rtn=rtn.substring(0,rtn.length-1);
       }
      
       return rtn;
    },
    isNullFormat(data){
       if(data==null||data==""||data==undefined){
           return false;
       }else{
           return true;
       }
    },
    prefixInteger(num, length) {
        return (Array(length).join('0') + num).slice(-length);
    },
              
}


// WEBPACK FOOTER //
// ./src/utils/util.js